import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

import classes from "./printInventory.module.scss";
import { ReactComponent as QrCodeIcon } from "@/assets/images/icons/Inventory/qr-code.svg";

import { dateToLocale, formatMilesDecimal } from "@/services/Utils";

const PrintInventoryTag = ({ handlePrint, handlePrintRow }) => {
	const { tags_available } = useSelector((state) => state.inventory);

	return (
		<>
			<Row>
				<Col xs={12} md={12} className={classes.scrollDivTable}>
					<table className={classes.tableSimple}>
						<thead>
							<tr>
								<th>Producto</th>
								<th>Contenido Envase</th>
								<th>Unidad de Medida</th>
								<th>Fecha Vencimiento</th>
								<th>Cantidad</th>
								{/* <th></th> */}
							</tr>
						</thead>
						<tbody>
							{tags_available &&
								tags_available.map((tag, i) => {
									return (
										<tr key={i}>
											<td>{tag.tradename}</td>
											<td>{formatMilesDecimal(tag.container_content)}</td>
											<td>{tag.unit_measurement}</td>
											<td>{tag.expiration_date ? dateToLocale(tag.expiration_date) : ""}</td>
											<td>{tag.quantity_available}</td>
											<td>
												<div
													style={{
														color: "white",
														background: "#8ac24e",
														borderRadius: "10px",
														marginRight: "5px",
														cursor: "pointer",
													}}
													onClick={() => handlePrintRow(tag, i)}
												>
													Imprimir
												</div>
											</td>
										</tr>
									);
								})}
						</tbody>
					</table>
				</Col>
			</Row>
			<Row>
				<Col xs={12} md={12}>
					<div className={`${classes.selecttags} ${classes.active}`} onClick={(_e) => handlePrint("newtags")}>
						<QrCodeIcon className={classes.icon} />
						<span className={classes.title}>Imprimir todas las etiquetas nuevas</span>
					</div>
				</Col>
			</Row>
		</>
	);
};

export default PrintInventoryTag;
